import React, { useEffect, useState } from 'react'
import { GoDotFill } from 'react-icons/go'
import Assessors from './MitigationComponents/Assessors'
import ViewTasktable from './MitigationComponents/ViewTasktable'
import { MITITGATION_APPROACH, REDUCTION_ID } from 'src/Entities/RiskTypes'
import { useRiskStore } from './Store/RiskStore'
import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'
import { cn } from 'src/lib/utils'
import dayjs from 'dayjs'

const MitigationView = () => {
    const { RiskDetailsById } = useRiskStore()
    const [ getData, setGetData ] = useState({})
    const { getDepOrganizations, allDepartments } = useGovernanceStore()
    const [ departments, setDepartments ] = useState([])
    const orgId = localStorage.getItem('orgId')
    useEffect(() => {
        if (allDepartments?.length > 0) {
            setDepartments(allDepartments)
        }
    }, [allDepartments])

    useEffect(() => {
        if (RiskDetailsById?.mitigation) {
            setGetData(RiskDetailsById?.mitigation)
            getDepOrganizations(orgId)
        }
    }, [RiskDetailsById])

    return (
        <div className='text-primary h-[100%] overflow-auto flex flex-col gap-7 p-5'>
            <div className='text-primary text-subHeading-2 p-3 rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'><GoDotFill size={8} /> Mitigation Plan</div>
            <div className={cn('flex', getData?.approachId === REDUCTION_ID ? 'justify-around' : 'justify-start gap-10 pl-4')}>
                <div>
                    <div className='text-primary text-subHeading-2'>
                Approach
                    </div>
                    <div className='text-muted text-b5'>
                        {MITITGATION_APPROACH?.find((ele) => ele.value === getData?.approachId)?.label}
                    </div>
                </div>
                <div>
                    <div className='text-primary text-subHeading-2'>
                Justification
                    </div>
                    <div className='text-muted text-b5'>
                        {getData?.justification}
                    </div>
                </div>

                {getData?.approachId === REDUCTION_ID && <div>
                    <div className='text-primary text-subHeading-2' >
                        Mitigation Budget
                    </div>
                    <div className='text-muted text-b5'>
                        {getData?.mitigationBudget}
                    </div>
                </div>}
            </div>
            {getData?.approachId === REDUCTION_ID && <>
                <div className='text-primary text-subHeading-2 p-3 rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'><GoDotFill size={8} />Task List</div>
                <Assessors data={RiskDetailsById?.analyzeResponse?.qualitativeRiskAssessment} />
                <div className='flex'>
                    <div className='text-primary text-subHeading-2'>
                        Resolution Date :
                    </div>
                    <div className='text-muted text-b5'>
                        {dayjs(getData?.resolutionDate).format('DD/MM/YYYY')}
                    </div>
                </div>
                <ViewTasktable departments={departments} data={getData?.taskLists?.length > 0 ? getData?.taskLists : RiskDetailsById?.riskInformation?.suggestedMitigation} monitoringView={false} />
            </>}
        </div>
    )
}

export default MitigationView
